import { Box, Typography } from '@mui/material';
import zeplinColor from 'theme/Color';
import { Lead, LeadKanbanColumn, LeadKanbanColumnId } from 'model/leads.model';
import { LeadsKanbanCard } from '../LeadsKanbanCard/LeadsKanbanCard';

export type { Lead, LeadKanbanColumn, LeadKanbanColumnId };

type LeadsKanbanColumnProps = {
  columnId: LeadKanbanColumnId;
  label: string;
  color: string;
  leads: Lead[];
  isLoading?: boolean;
  isDeleting?: boolean;
  onDragOver: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent, targetColumn: LeadKanbanColumnId) => void;
  onDragStart: (e: React.DragEvent, leadId: string, sourceColumn: LeadKanbanColumnId) => void;
  onStatusChange?: (leadId: string, status: LeadKanbanColumnId) => void;
  onDelete?: (leadId: string, onComplete?: () => void) => void;
  onViewDetails?: (lead: Lead) => void;
};

export const LeadsKanbanColumn = ({
  columnId,
  label,
  color,
  leads,
  isLoading = false,
  isDeleting,
  onDragOver,
  onDrop,
  onDragStart,
  onStatusChange,
  onDelete,
  onViewDetails,
}: LeadsKanbanColumnProps) => (
  <Box
    sx={{
      width: '100%',
    }}
    onDragOver={onDragOver}
    onDrop={(e) => onDrop(e, columnId)}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px 12px 8px 0px',
        marginBottom: '8px',
      }}
    >
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <Box
          sx={{
            width: '8px',
            height: '8px',
            borderRadius: '100%',
            backgroundColor: color,
          }}
        />
        <Typography
          variant='heading3'
          sx={{
            color: zeplinColor.BasicBlack,
          }}
        >
          {label} ({leads.length})
        </Typography>
      </Box>
    </Box>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {isLoading
        ? Array.from({ length: 4 }).map((_, index) => (
            <LeadsKanbanCard
              key={`lead-skeleton-${columnId}-${index}`}
              lead={undefined}
              columnId={columnId}
              isDeleting={isDeleting}
              isLoading
              onDragStart={onDragStart}
              onStatusChange={onStatusChange}
              onDelete={onDelete}
              onViewDetails={onViewDetails}
            />
          ))
        : leads.map((lead) => (
            <LeadsKanbanCard
              key={lead.leadId}
              lead={lead}
              columnId={columnId}
              isDeleting={isDeleting}
              onDragStart={onDragStart}
              onStatusChange={onStatusChange}
              onDelete={onDelete}
              onViewDetails={onViewDetails}
            />
          ))}
    </Box>
  </Box>
);
